module.exports = __webpack_public_path__ + "img/Edit Patient - Green - Selected.ac4d3433.png";